import Vue from 'vue'
import Vuex from 'vuex'
import websites from './websites'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    websites
  }
})
